;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Collection = APP.module('Collection');
	var Model      = APP.module('Model');

	Collection.Celebrities =  Backbone.Collection.extend({
		model: Model.Celebrity,
		api_prefix: '',

		isNew: function() {
			return true;
		},

		show_for_join: function() {
			this.setApiUrl('show_for_join');

			return this;
		},

		show_for_clone: function() {
			this.setApiUrl('show_for_clone');

			return this;
		},

		join: function(league_id, teams) {
			this.setApiUrl('join')
				.save({ league_id: league_id, teams: teams }, {
					ajaxSync: true,
					success: function(model, resp) {
						if (resp.errors.length) {
							this.trigger('leagues:celebrities_join:errors', resp.errors);
						}
						else {
							this.trigger('leagues:celebrities_join:success');
						}
					}
				});

			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));